import { useEffect, useState } from "react";
import { api } from "./api";
import { COPY } from "../content/copy";

// impostazioni del sito (link, testi) modificabili da /scrivi → Sito; una sola richiesta, condivisa
let cache = null;
let pending = null;
export const loadSettings = () => {
    if (cache) return Promise.resolve(cache);
    if (!pending) {
        pending = fetch(api("/settings"))
            .then((r) => (r.ok ? r.json() : {}))
            .catch(() => ({}))
            .then((s) => (cache = s));
    }
    return pending;
};
export const resetSettings = () => {
    cache = null;
    pending = null;
    window.dispatchEvent(new Event("apf:settings-updated"));
};

export const useSettings = () => {
    const [s, setS] = useState(cache);
    useEffect(() => {
        let mounted = true;
        const refresh = () => loadSettings().then((data) => { if (mounted) setS(data); });
        refresh();
        window.addEventListener("apf:settings-updated", refresh);
        return () => { mounted = false; window.removeEventListener("apf:settings-updated", refresh); };
    }, []);
    return s || {};
};

export const TEXT_DEFAULTS = {
    headline_a: COPY.apertura.headlineA,
    headline_b: COPY.apertura.headlineB,
    apertura_sub: COPY.apertura.sub,
    chiusura_title: COPY.chiusura.title,
    chiusura_sub: COPY.chiusura.sub,
    chiusura_closing: COPY.chiusura.closing,
};

export const useTexts = () => {
    const s = useSettings();
    return { ...TEXT_DEFAULTS, ...(s.texts || {}) };
};
